import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    title: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    active: {
      fontSize: '12px',
      backgroundColor: 'rgba(59, 189, 219, 0.1)',
      borderRadius: 16,
      padding: '3px 8px',
      color: '#3BBDDB'
    },
  })
);
